/**
 * PLACEHOLDER ANIMATION COMPONENT
 * Shows loading animation with category-specific messages
 */

import React from 'react';

interface PlaceholderAnimationProps {
  message: string;
}

const PlaceholderAnimation: React.FC<PlaceholderAnimationProps> = ({ message }) => {
  return (
    <div className="flex flex-col space-y-2">
      <div className="p-3 rounded-2xl max-w-[75%] bg-gray-200 text-gray-800 self-start">
        <span>{message}</span>
      </div>
    </div>
  );
};

export default PlaceholderAnimation;

